import { Dropdown } from "semantic-ui-react";

const TeamMembersDropdown = ({
  availableTeamMembers,
  isLoading,
  setSearchQuery,
  handleAddTeamMember,
}) => {
  return (
    <>
      <Dropdown
        placeholder="Search by name…"
        search
        selection
        clearable
        selectOnBlur={false}
        pageSize={10}
        options={availableTeamMembers}
        loading={isLoading}
        onSearchChange={(e, { searchQuery }) => setSearchQuery(searchQuery)}
        onBlur={() => setSearchQuery("")}
        onClose={() => setSearchQuery("")}
        onChange={(e, { value }) => {
          const user = availableTeamMembers.find((o) => o.value === value);
          user &&
            handleAddTeamMember({
              id: user.key,
              name: user.text,
              supervisor: false,
            });
        }}
      />
    </>
  );
};

export default TeamMembersDropdown;
